import img1 from '../assets/image/Banner1.jpg';

const data = [
    {
        "id": 1,
        "name": "Sparkle In Every Moment With Our Exclusive Collections.",
        "dec":"Create your own style and spread your energy, the community will reward you!",
        "img": img1,
        "position": "center",
        "speed": 1,
        "btn":"View Collection",
    }
];

export default data;
